<template>
  <span v-if="$slots.default" class="error-retry-actions" role="group" v-bind="$attrs"><slot /></span>
</template>
<script setup>
import { watch } from 'vue'
import { showFeedback } from '../../services/feedback'
defineOptions({ inheritAttrs: false })
const props = defineProps({ message: { type: [String, Error], default: '' } })
watch(() => props.message, message => { if (message) showFeedback(message, 'error') }, { immediate: true })
</script>
